






import {Component, Vue} from 'vue-property-decorator';
import {Getter} from 'vuex-class';

import {AUTH_GET_CLIENT, AUTH_GET_COUNTRY, AUTH_GET_VEHICLETYPE} from '@/store/modules/authentication/types';
import {Client} from '@/store/modules/authentication/interfaces';
import {TupleDictionary} from '@/utils/tupleDictionary';
import {ClientEnum} from '@/enums/client.enum';
import {CountryEnum, CountryType} from '@/enums/country.enum';
import ReportPowerBiContainer from '@/modules/neodash/components/report-powerbi-container/report-powerbi-container.vue';
import {traceLogAccess} from '@/services';
import {ContextEnum} from '@/enums/context.enum';
import PbiDictWorkspaceId, { PbiWorkspacesEnum } from '@/modules/neodash/containers/powerbi/pbi-dict-workspace-id';
import { VehicleTypeEnum } from '@/enums/vehicle-type.enum';

@Component({
  name: 'PbiMulticriteriaAnalysisPage',
  components: { ReportPowerBiContainer }
})
export default class PbiMulticriteriaAnalysisPage extends Vue {
  @Getter(AUTH_GET_CLIENT)
  public client: Client;

  @Getter(AUTH_GET_COUNTRY)
  public country: CountryType;

  @Getter(AUTH_GET_VEHICLETYPE)
  public idVehicleType: number;

  private pbiDictWorkspaceId = new PbiDictWorkspaceId();
  public dictReports = new TupleDictionary<[ClientEnum, VehicleTypeEnum, CountryType], IPbiContainer>();
  public crrReport: IPbiContainer = { brand: '', workspaceId: '', reportId: '' };

  mounted() {
    this.dictReports.set([ClientEnum.Honda, VehicleTypeEnum.Motorcycle, CountryEnum.Brasil], { brand: 'Honda Motos', workspaceId: this.pbiDictWorkspaceId.dictionary.get([PbiWorkspacesEnum.Neodash]), reportId: 'cbb745fc-c5fc-438d-953e-46adf1bab24b' });

    this.crrReport = this.dictReports.get([this.client.id, this.idVehicleType, this.country]);
    traceLogAccess.logAction(ContextEnum.Report, `${this.crrReport.brand} - Multicriteria Analysis`);
  }
}
